import { snackbar } from "@/core/controller/snackbar_controller";
import { headers } from "../const/headers";
import { truckDriverDefault } from "../domain/truckDriver/truckDriver";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

class TruckDriverController {
  context = null;
  headers = headers
  loading = false
  search = ""
  searchEquipment = ""
  equipmentIDsToInclude = null
  dialog = false
  equipmentsDialog = false
  form = truckDriverDefault()
  equipmentSelected = []
  statusPaginated = 1

  emailRules = value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'E-mail inválido.'
  }

  phoneRules = value => {
    const digits = (value || '').replace(/\D/g, '');
    return digits.length === 11 || 'Telefone inválido.';
  }


  formatDate(date) {
    if (!date) return ''
    const dateOnly = date.split('T')[0]
    const [year, month, day] = dateOnly.split('-')
    return `${day}/${month}/${year}`
  }

  selectedEquipments = []

  equipmentHeaders = [
    {
      text: 'Serial',
      align: 'start',
      sortable: true,
      value: 'name',
    },
  ]

  truckDriverPagination = {
    total: 0,
    items: []
  }

  options = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  equipmentPagination = {
    total: 0,
    items: []
  }

  equipmentOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  constructor(
    context,
    fetchTruckDriverUseCaseImpl,
    createTruckDriverUseCaseImpl,
    changeTruckDriverUseCaseImpl,
    deleteTruckDriverUseCaseImpl,
    fetchEquipmentUseCaseImpl,
    getVisibleEquipmentsByTruckDriverIDUsecaseImpl,
  ) {
    this.context = context;
    this.fetchTruckDriverUseCaseImpl = fetchTruckDriverUseCaseImpl
    this.createTruckDriverUseCaseImpl = createTruckDriverUseCaseImpl
    this.changeTruckDriverUseCaseImpl = changeTruckDriverUseCaseImpl
    this.deleteTruckDriverUseCaseImpl = deleteTruckDriverUseCaseImpl
    this.getVisibleEquipmentsByTruckDriverIDUsecaseImpl = getVisibleEquipmentsByTruckDriverIDUsecaseImpl
    this.fetchEquipmentUseCaseImpl = fetchEquipmentUseCaseImpl
  }
  
  validateDate(dateStr) {
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
        return false;
    }

    const date = dayjs.utc(dateStr, 'DD/MM/YYYY');
    if (!date.isValid()) {
        return false;
    }

    if (date.isAfter(dayjs.utc())) {
        return false;
    }

    this.form.birthDate = date.format('YYYY-MM-DD');
    return true;
  }

  async paginate() {
    this.loading = true
    try {
      this.truckDriverPagination = await this.fetchTruckDriverUseCaseImpl(this.options, this.search, this.statusSelected)
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }

  async equipmentPaginate() {
    try {
      this.equipmentPagination = await this.fetchEquipmentUseCaseImpl(this.equipmentOptions, this.searchEquipment, this.statusPaginated, this.equipmentIDsToInclude)
    } catch (error) {
      console.log(error);
    }
  }

  open() {
    this.dialog = true
    this.form = truckDriverDefault()
  }

  close() {
    this.context.$refs.crud.resetValidation()
    this.dialog = false
    this.form = truckDriverDefault({})
  }

  async create() {
    if (this.context.$refs.crud.validate()) {
      try {
        this.loading = true;
        const formData = { ...this.form };
        if (this.form.id != 0) {
          await this.changeTruckDriverUseCaseImpl(this.form.id, formData);
          snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 });
        } else {
          await this.createTruckDriverUseCaseImpl(formData);
          snackbar.show({ message: "Adicionado com sucesso!!!", color: "#008000", timeout: 3000 });
        }
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 });
      } finally {
        this.paginate();
        this.loading = false
        this.close()
      }
    }
  } 

  change(item) {
    this.dialog = true;
    this.form = { ...item };
    if (this.form.birthDate) {
        const [year, month, day] = this.form.birthDate.split('T')[0].split('-');
        this.form.birthDateFormatted = `${day}/${month}/${year}`;
    }
  }

  async delete(item) {
    try {
      const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
      if (confirm) {
        await this.deleteTruckDriverUseCaseImpl(item.id)
        this.paginate()
        snackbar.show({ message: "Resgistro excluído com sucesso!", color: "#008000", timeout: 1000 })
      }
    } catch (error) {
      snackbar.show({ message: error.toString() })
    }
  }


  watchOptions() {
    this.paginate()
  }

  watchSearch() {
    this.paginate()
  }

  changeStatus() {
    this.paginate()
  }

  watchEquipmentOptions() {
    this.equipmentPaginate()
  }

  watchEquipmentSearch() {
    this.equipmentPaginate()
  }

  async changeEquipment(item) {
    const linkedEquipments = await this.getVisibleEquipmentsByTruckDriverIDUsecaseImpl(item.id)
    
    this.equipmentSelected = linkedEquipments
    
    this.equipmentIDsToInclude = linkedEquipments.length > 0 
      ? linkedEquipments.map(e => e.id).join(',') 
      : null
  
    this.form = { ...item }
    
    this.equipmentOptions.page = 1
    await this.equipmentPaginate()

    this.equipmentsDialog = true
  }

  closeEquipmentDialog() {
    this.equipmentsDialog = false
    this.equipmentIDsToInclude = null
    this.equipmentSelected = []
  }
  isSelectedEquipment(item) {
    return this.equipmentSelected.some((el) => el.id === item.id);
  }
  toggleItemEquipment(item) {
    if (this.equipmentSelected.some((el) => el.id === item.id)) {
      this.removeItemEquipment(item);
    } else {
      this.equipmentSelected.push(item);
    }
  }
  removeItemEquipment(item) {
    if (this.equipmentSelected.some((el) => el.id == item.id)) {
      let index = this.equipmentSelected.map((e) => e.id).indexOf(item.id);
      if (index > -1) {
        this.equipmentSelected.splice(index, 1);
      }
    }
  }

  async saveEquipmentVisibility() {
    this.form.visibleEquipment = this.equipmentSelected.length > 0 ? this.equipmentSelected.map((equipment) => equipment.id).join(",") : null
    try {
      await this.changeTruckDriverUseCaseImpl(this.form.id, this.form)
      //await this.refreshUseCaseImpl()
      snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
      
    } catch (error) {
      snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
    } finally {
      this.closeEquipmentDialog()
    }
  }

}

export default TruckDriverController